import script from "./MaterialDetailsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./MaterialDetailsModal.vue?vue&type=script&setup=true&lang=ts"

import "./MaterialDetailsModal.vue?vue&type=style&index=0&id=1126808a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1126808a"]])

export default __exports__